<template>
    <li :id="item.tab" class="nav-item" :class="{ active: isActive, hide: item.hide, disabled: item.disabled }">
        <b-link class="d-flex align-items-center" @click="changeActiveTab">
            <font-awesome-icon :icon="item.icon || ['fas', 'circle']" />
            <span class="menu-title text-truncate">{{ item.title }}</span>
            <b-badge v-if="item.tag" class="mr-1 ml-auto" :variant="item.tagVariant || 'primary'" pill>
                {{ item.tag }}
            </b-badge>
        </b-link>
    </li>
</template>

<script>
import { mapGetters } from 'vuex';
import { BLink, BBadge } from 'bootstrap-vue';

export default {
    components: { BLink, BBadge },
    props: { item: { type: Object, required: true } },
    computed: {
        ...mapGetters('guest', ['invoicesTab']),
        isActive() {
            return this.item.tab == this.invoicesTab;
        },
    },
    methods: {
        changeActiveTab() {
            this.$store.dispatch('guest/setInvoicesTab', this.item.tab);
            this.replaceRouteQuery(this.item.tab);
            this.scrollToActiveTab();
        },
        scrollToActiveTab() {
            const activeTab = document.getElementById(this.item.tab);
            activeTab.scrollIntoView({
                block: 'nearest',
                inline: 'center',
            });
        },
        replaceRouteQuery(tab) {
            this.$router
                .replace({
                    path: this.$route.path,
                    query: {
                        ...this.$route.query,
                        tab: tab,
                    },
                })
                .catch((err) => {});
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../../../../scss/bootstrap-extended/bootstrap-extended.scss';

:deep(.badge) {
    background: linear-gradient(118deg, rgba($primary, 1), rgba($primary, 0.7));
    background-color: transparent !important;
    box-shadow: 0 0 10px 1px rgba($primary, 0.7);
}
</style>
